var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgDuration = function SvgVaknlLgDuration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3D9B8B",
    strokeWidth: 1.5,
    d: "M19 10c0 .337-.018.673-.054 1.008a9.011 9.011 0 0 1-7.938 7.938 9.435 9.435 0 0 1-2.016 0 9.011 9.011 0 0 1-7.938-7.938 9.435 9.435 0 0 1 0-2.016 9.011 9.011 0 0 1 7.938-7.938 9.435 9.435 0 0 1 2.016 0 9.011 9.011 0 0 1 7.938 7.938c.036.335.054.671.054 1.008z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 10h1M0 10h1m9 9v1m0-20v1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3.5,
    fill: "#F3AD05",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.4 8.195 3.606 1.803M15.5 5.5l-5.494 4.498"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20 10c0 .374-.02.748-.06 1.12a10.012 10.012 0 0 1-8.82 8.82c-.745.08-1.495.08-2.24 0a10.012 10.012 0 0 1-8.82-8.82c-.08-.745-.08-1.495 0-2.24A10.012 10.012 0 0 1 8.88.06c.745-.08 1.495-.08 2.24 0a10.012 10.012 0 0 1 8.82 8.82c.04.372.06.746.06 1.12z"
  }))));
};
export default SvgVaknlLgDuration;